import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DateAdapter, MatDialogRef, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA } from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ToastrManager } from "ng6-toastr-notifications";
import { Sociedad } from "../../../_core/model/sociedad";
import { PersonalActivoService } from "../../../_core/services/personal-activo.service";
import { Turno } from "../../../_core/model/turno";
import { Sede } from "../../../_core/model/sede";

export const MY_FORMATS = {
	parse: {
		dateInput: "DD/MM/YYYY",
	},
	display: {
		dateInput: "DD/MM/YYYY",
		monthYearLabel: "MMMM YYYY",
		dateA11yLabel: "DD/MM/YYYY",
		monthYearA11yLabel: "MMMM YYYY",
	},
};

@Component({
	selector: "m-insert-update-personal-activo",
	templateUrl: "./insert-update-personal-activo.component.html",
	styleUrls: ["./insert-update-personal-activo.component.scss"],
	providers: [DatePipe, { provide: MAT_DATE_LOCALE, useValue: "es" }, { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class InsertUpdatePersonalActivoComponent implements OnInit {
	viewLoading: boolean = false;
	form: FormGroup;
	updateButton: boolean = false;

	sociedades: Array<Sociedad> = [];
	turnos: Array<Turno> = [];
	sedes: Array<Sede> = [];
	plazos: any[] = [];
	generos: any[] = [];
	estados: any[] = [];
	ciudades: any[] = [];
	cargos: any[] = [];
	sistemas: any[] = [];
	bancos: any[] = [];
	// generos = [
	//   {
	//     id: 'F',
	//     value: 'Femenino'
	//   }, {
	//     id: 'M',
	//     value: 'Masculino'
	//   }
	// ]

	constructor(
		public toastr: ToastrManager,
		public dialogRef: MatDialogRef<InsertUpdatePersonalActivoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		//private sociedadService: SociedadService,
		private datePipe: DatePipe,
		public personaActivoService: PersonalActivoService
	) {}

	usuarioId: number;
	ngOnInit() {
		this.form = new FormGroup({
			Nombres: new FormControl(null, Validators.required),
			DocIdentidad: new FormControl(null, Validators.required),
			IsActivo: new FormControl(true, []),
			IsSupervisor: new FormControl(false, []),
			Sociedad: new FormControl(null, Validators.required),
			Turno: new FormControl(null),
			Sede: new FormControl(null),
			ApellidoPaterno: new FormControl(null, Validators.required),
			ApellidoMaterno: new FormControl(null, Validators.required),
			FechaInicioContrato: new FormControl(null, Validators.required),
			FechaFinContrato: new FormControl(null),
			PlazoContratacion: new FormControl(null, Validators.required),
			Genero: new FormControl(null, Validators.required),
			EstadoCivil: new FormControl(null, Validators.required),
			HijosMenores: new FormControl(false),
			EdadHijo: new FormControl(null),
			NivelEstudios: new FormControl(null, Validators.required),
			FechaNacimiento: new FormControl(null),
			Direccion: new FormControl(null, Validators.required),
			Ciudad: new FormControl(null, Validators.required),
			Telefono: new FormControl(null),
			NombreContactoEmergencia: new FormControl(null),
			NroContactoEmergencia: new FormControl(null),
			Correo: new FormControl(null, Validators.required),
			Cargo: new FormControl(null, Validators.required),
			SistemaPensiones: new FormControl(null, Validators.required),
			AntiguedadLaboral: new FormControl(null, Validators.required),
			NroCuentaBancaria: new FormControl(null, Validators.required),
			Banco: new FormControl(null, Validators.required),
			NroCuentaInterbancaria: new FormControl(null, Validators.required),
		});

		this.personaActivoService.listarSociedad().subscribe((response) => {
			this.sociedades = response as Array<Sociedad>;
		});

		this.personaActivoService.listarTurno().subscribe((response) => {
			this.turnos = response as Array<Turno>;
		});

		this.personaActivoService.listarSede().subscribe((response) => {
			this.sedes = response as Array<Sede>;
		});

		this.personaActivoService.listarPlazoContratacion().subscribe((response: any) => {
			this.plazos = response;
		});

		this.personaActivoService.listarGenero().subscribe((response: any) => {
			this.generos = response;
		});

		this.personaActivoService.listarEstadoCivil().subscribe((response: any) => {
			this.estados = response;
		});

		this.personaActivoService.listarCiudad().subscribe((response: any) => {
			this.ciudades = response;
		});

		this.personaActivoService.listarCargo().subscribe((response: any) => {
			this.cargos = response;
		});

		this.personaActivoService.listarSistemaPensiones().subscribe((response: any) => {
			this.sistemas = response;
		});

		this.personaActivoService.listarBanco().subscribe((response: any) => {
			this.bancos = response;
		});

		this.usuarioId = this.data.data.Usuario;
		if (this.usuarioId !== -1) {
			this.updateButton = true;
			this.viewLoading = false;
			this.loadData(this.data.data.Usuario);
		} else {
			this.updateButton = false;
		}
	}

	loadData(data) {
		this.form.controls["Nombres"].setValue(data.Nombres);
		this.form.controls["DocIdentidad"].setValue(data.DocumentoIdentidad);
		this.form.controls["Sociedad"].setValue(Number(data.Empresa));
		this.form.controls["ApellidoPaterno"].setValue(data.ApellidoPaterno);
		this.form.controls["ApellidoMaterno"].setValue(data.ApellidoMaterno);

		// this.form.controls["IsSupervisor"].setValue(data.Supervisor);
		this.form.controls["IsActivo"].setValue(data.Activo);
		this.form.controls["Turno"].setValue(data.Turno);
		this.form.controls["Sede"].setValue(data.Sede);

		this.form.controls["FechaInicioContrato"].setValue(data.FechaInicioContrato);
		this.form.controls["FechaFinContrato"].setValue(data.FechaFinContrato);
		this.form.controls["PlazoContratacion"].setValue(data.PlazoContratacion);
		this.form.controls["Genero"].setValue(data.Genero);
		this.form.controls["EstadoCivil"].setValue(data.EstadoCivil);
		this.form.controls["HijosMenores"].setValue(data.HijosMenores);
		this.form.controls["EdadHijo"].setValue(data.EdadHijo);
		this.form.controls["NivelEstudios"].setValue(data.NivelEstudios);
		this.form.controls["FechaNacimiento"].setValue(data.FechaNacimiento);
		this.form.controls["Direccion"].setValue(data.Direccion);
		this.form.controls["Ciudad"].setValue(data.Ciudad);
		this.form.controls["Telefono"].setValue(data.Telefono);
		this.form.controls["NombreContactoEmergencia"].setValue(data.NombreContactoEmergencia);
		this.form.controls["NroContactoEmergencia"].setValue(data.NroContactoEmergencia);
		this.form.controls["Correo"].setValue(data.Correo);
		this.form.controls["Cargo"].setValue(data.Cargo);
		this.form.controls["SistemaPensiones"].setValue(data.SistemaPensiones);
		this.form.controls["AntiguedadLaboral"].setValue(data.AntiguedadLaboral);
		this.form.controls["Banco"].setValue(data.Banco);
		this.form.controls["NroCuentaBancaria"].setValue(data.NroCuentaBancaria);
		this.form.controls["NroCuentaInterbancaria"].setValue(data.NroCuentaInterbancaria);
	}

	onSubmit() {
		const controls = this.form.controls;
		if (this.form.invalid) {
			Object.keys(controls).forEach((contusuarioPersonalName) => controls[contusuarioPersonalName].markAsTouched());
			this.toastr.warningToastr("Ingrese los campos obligatorios.", "Advertencia!", {
				toastTimeout: 2000,
				showCloseButton: true,
				animate: "fade",
				progressBar: true,
			});
			return;
		} else {
			this.viewLoading = true;
			const Nombres = this.form.controls["Nombres"].value;
			const DocIdentidad = this.form.controls["DocIdentidad"].value;
			// const IsSupervisor = this.form.controls["IsSupervisor"].value;
			const IsActivo = this.form.controls["IsActivo"].value;
			const Sociedad = this.form.controls["Sociedad"].value;
			const ApellidoPaterno = this.form.controls["ApellidoPaterno"].value;
			const ApellidoMaterno = this.form.controls["ApellidoMaterno"].value;
			const Turno = this.form.controls["Turno"].value ? this.form.controls["Turno"].value : null;
			const Sede = this.form.controls["Sede"].value ? this.form.controls["Sede"].value : null;

			const FechaInicioContrato = this.datePipe.transform(this.form.controls["FechaInicioContrato"].value, 'yyyy-MM-dd');
			const FechaFinContrato = this.datePipe.transform(this.form.controls["FechaFinContrato"].value, 'yyyy-MM-dd');
			const PlazoContratacion = this.form.controls["PlazoContratacion"].value ? this.form.controls["PlazoContratacion"].value : null;
			const Genero = this.form.controls["Genero"].value ? this.form.controls["Genero"].value : null;
			const EstadoCivil = this.form.controls["EstadoCivil"].value ? this.form.controls["EstadoCivil"].value : null;
			const HijosMenores = this.form.controls["HijosMenores"].value;
			const EdadHijo = this.form.controls["EdadHijo"].value ? this.form.controls["EdadHijo"].value : null;
			const NivelEstudios = this.form.controls["NivelEstudios"].value ? this.form.controls["NivelEstudios"].value : null;
			const FechaNacimiento = this.datePipe.transform(this.form.controls["FechaNacimiento"].value, 'yyyy-MM-dd');
			const Direccion = this.form.controls["Direccion"].value ? this.form.controls["Direccion"].value : null;
			const Ciudad = this.form.controls["Ciudad"].value ? this.form.controls["Ciudad"].value : null;
			const Telefono = this.form.controls["Telefono"].value ? this.form.controls["Telefono"].value : null;
			const NombreContactoEmergencia = this.form.controls["NombreContactoEmergencia"].value ? this.form.controls["NombreContactoEmergencia"].value : null;
			const NroContactoEmergencia = this.form.controls["NroContactoEmergencia"].value ? this.form.controls["NroContactoEmergencia"].value : null;
			const Correo = this.form.controls["Correo"].value ? this.form.controls["Correo"].value : null;
			const Cargo = this.form.controls["Cargo"].value ? this.form.controls["Cargo"].value : null;
			const SistemaPensiones = this.form.controls["SistemaPensiones"].value ? this.form.controls["SistemaPensiones"].value : null;
			const Banco = this.form.controls["Banco"].value ? this.form.controls["Banco"].value : null;
			const NroCuentaBancaria = this.form.controls["NroCuentaBancaria"].value ? this.form.controls["NroCuentaBancaria"].value : null;
			const NroCuentaInterbancaria = this.form.controls["NroCuentaInterbancaria"].value ? this.form.controls["NroCuentaInterbancaria"].value : null;

			this.personaActivoService.guardar(this.usuarioId === -1 ? -1 : 2, Nombres, DocIdentidad, IsActivo, Sociedad, ApellidoPaterno, ApellidoMaterno, Turno, Sede,
				FechaInicioContrato, FechaFinContrato, PlazoContratacion, Genero, EstadoCivil, HijosMenores, EdadHijo, NivelEstudios, FechaNacimiento, Direccion, Ciudad, Telefono,
                    NombreContactoEmergencia, NroContactoEmergencia, Correo, Cargo, SistemaPensiones, Banco, NroCuentaBancaria, NroCuentaInterbancaria).subscribe(
				(response: any) => {
					this.viewLoading = false;
					if (response === -1) {
						this.toastr.infoToastr("El personal ingresado ya existe", "Información!", {
							toastTimeout: 4000,
							showCloseButton: true,
							animate: "fade",
							progressBar: true,
						});
						return;
					}

					if (response === 2) {
						this.dialogRef.close(true);
						this.toastr.successToastr("Se registro correctamente.", "Éxito!", {
							toastTimeout: 3000,
							showCloseButton: true,
							animate: "fade",
							progressBar: true,
						});
						return;
					}
				},
				(error) => {
					this.viewLoading = false;
					this.toastr.errorToastr(error.error.Message, "Error!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
				}
			);
		}
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	parseDate(dateStr: string) {
		const date = new Date(dateStr);
		return this.datePipe.transform(date, "yyyy-MM-dd");
	}

	changeFechaInicio() {
		this.form.controls.AntiguedadLaboral.setValue(this.monthDiff(new Date(this.form.controls.FechaInicioContrato.value), new Date()));
	}

	monthDiff(d1, d2) {
		var months;
		months = (d2.getFullYear() - d1.getFullYear()) * 12;
		months -= d1.getMonth();
		months += d2.getMonth();
		return months <= 0 ? 0 : months;
	}
}
